module.exports = __webpack_public_path__ + "img/prices.957ada26.svg";